import React from 'react';
import authHeader from '../../services/auth-header';
import './index.css';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import TestsListItemComponent from './TestsListItemComponent';


export default class TestsListComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {}

        this.getList()
    }


    getList() {

        AuthService.getTests(authHeader).then(
            response => {

                const configs = response.data;

                console.log(configs);

                const items = configs.map(
                    data => {
                        return <TestsListItemComponent data={data} key={data.source}/>
                    }
                )

                this.setState({items: items})
            }
        )
    }

    render() {

        return (

            <>
            { this.state.result &&
            <div className='test-result-div'>
                <p>{this.state.result}</p>
            </div>
            }

            <div className='index-list-container'>
                
                <a href='/add-test' className='add-parser-page-btn'>{i18n.t("new_test")}</a>
                <br/>
                <table className='general-table'>

                    <thead>
                        <tr>
                            <th style={{width: "40%"}}>Name</th>
                            <th style={{width: "20%"}}>Edit</th>
                            <th style={{width: "20%"}}>Test</th>
                            <th style={{width: "20%"}}>Toggle</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.state.items}
                    </tbody>
                </table>

            </div>
            </>
            
        );

    }
}